<script lang="ts">
  import Grid from "$lib/components/Grid/Grid.svelte";
  import Column from "$lib/components/Column/Column.svelte";
  import EditorialCard from "$lib/components/Cards/EditorialCard/EditorialCard.svelte";
  import Container from "$lib/components/Container/Container.svelte";
  import type { Link, FliteImage } from "$lib/gql/genCms/codegen";

  export let title: string;
  export let cta: Link;
  export let image: FliteImage;
  export let title2: string;
  export let cta2: Link;
  export let image2: FliteImage;
  export let animate = false;
  export let invert = false;
</script>

<style lang="scss">
  .two-image-hero {
    padding: 2rem 0;
    border-bottom: 1px solid $background;
    background-color: $inverse-on-surface !important;
    &--invert {
      background-color: $inverse-surface !important;
    }
    @include retina {
      border-bottom: 0.5px solid $background;
    }

    @include breakpoint(md) {
      padding: 44px 0;
    }

    @include breakpoint(lg) {
      padding: 52px 0;
    }
  }
</style>

<div
  class="two-image-hero {invert ? 'two-image-hero--invert' : 'two-image-hero'}"
  data-cs-override-id="two-image-hero"
>
  <Container>
    <Grid smCols={4} mdCols={8} lgCols={12} xlCols={12}>
      <Column smSpan={4} mdSpan={4} lgSpan={6} xlSpan={6} xxlSpan={6}>
        <EditorialCard
          {title}
          {image}
          url={cta && cta?.href}
          ctaText={cta && cta?.text}
          twoImageHero
          {animate}
          {invert}
          colour={cta?.bgColour != undefined ? cta?.bgColour : ""}
          theme={!cta?.bgColour && invert ? "inverse-on-surface" : "on-surface"}
        />
      </Column>
      <Column
        smSpan={4}
        mdSpan={4}
        lgSpan={6}
        xlSpan={6}
        xxlSpan={6}
        mdStart={5}
        lgStart={7}
      >
        <EditorialCard
          title={title2}
          image={image2}
          url={cta2 && cta2?.href}
          ctaText={cta2 && cta2?.text}
          twoImageHero
          {invert}
          colour={cta2?.bgColour ? cta2?.bgColour : ""}
          theme={!cta2?.bgColour && invert
            ? "inverse-on-surface"
            : "on-surface"}
        />
      </Column>
    </Grid>
  </Container>
</div>
